<template>
  <v-card tile flat>
    <v-toolbar
      v-if="$vuetify.breakpoint.mobile"
      dark
      color="primary"
    >
      <v-btn
        icon
        dark
        @click="$emit('close-card-form')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>Add a Card</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-form
        ref="cardForm"
        v-model="valid"
        lazy-validation
      >
        <v-text-field
          tile
          required
          label="Card Name"
          v-model="integration.name"
          :rules="[v => !!v]"
          class="mb-3"
        ></v-text-field>
      </v-form>

      <div ref="cardInput"></div>
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="loading"
        @click="addIntegration"
      >
        <v-icon left>
          mdi-credit-card-plus-outline
        </v-icon>
        Add Card
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'StripeIntegration',

    computed: {
      stripePubKey: function () {
        return process.env.VUE_APP_STRIPE_PK
      }
    },

    data: () => ({
      // Form
      loading: false,
      valid: true,

      // Stripe
      stripe: null,
      elements: null,
      card: null,

      // Integration
      integration: {
        name: '',
        data: '',
        externamAccountName: 'Stripe Credit Account'
      }
    }),

    methods: {
      ...mapActions([
        'createUserIntegration'
      ]),

      addIntegration: function () {
        this.loading = true

        // Check validation
        this.valid = this.$refs.cardForm.validate()

        if (this.valid) {
          // Get a token from Stripe
          this.stripe.createToken(this.card).then((result) => {
            // Got a token!
            if (result.token) {
              this.integration.data = result.token.id

              // Pass the integration payload to the backend.
              this.createUserIntegration(this.integration).then(() => {
                console.log('Success!')
                this.loading = false
              })
              .catch((err) => {
                console.error(err)
              })
              .finally(() => this.$emit('close-card-form'))
            }

            // There was a problem.
            if (result.error) {
              this.loading = false
            }
          })
        }
        else {
          this.loading = false
        }
      }
    },

    mounted: function () {
      this.stripe = window.Stripe(this.stripePubKey)
      this.elements = this.stripe.elements()
      this.card = this.elements.create('card', {
        iconStyle: "solid",
      })

      this.card.mount(this.$refs.cardInput)
    }
  }
</script>
